export default __webpack_public_path__ + "6a5e83a2fcdacc5bbe6cd1e847a889d7.png";